import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 2,
  class: "ds-badge__text"
}

import DsIcon from "../icon/ds-icon.vue";
import { SvgBaseIcons } from "../icon/types";

// https://github.com/vuejs/core/issues/8952
type ConditionalProps =
    | {
          tag?: "button" | "span" | "div";
          href?: never;
      }
    | {
          tag?: "a";
          href: string;
      };


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-badge',
  props: {
    text: {},
    iconLeft: {},
    iconRight: {},
    isInStorybook: { type: Boolean },
    tag: { default: "div" },
    href: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: "ds-badge",
    href: _ctx.tag === 'a' ? _ctx.href : undefined,
    rel: _ctx.tag === 'a' ? 'noopener noreferrer' : undefined,
    target: _ctx.tag === 'a' ? '_blank' : undefined
  }, {
    default: _withCtx(() => [
      (_ctx.iconLeft)
        ? (_openBlock(), _createBlock(DsIcon, {
            key: 0,
            width: 16,
            height: 16,
            name: _ctx.iconLeft,
            "is-in-storybook": _ctx.isInStorybook,
            class: "ds-badge__icon-left"
          }, null, 8, ["name", "is-in-storybook"]))
        : _createCommentVNode("", true),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "ds-badge__text",
            innerHTML: _ctx.text
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])),
      (_ctx.iconRight)
        ? (_openBlock(), _createBlock(DsIcon, {
            key: 3,
            width: 16,
            height: 16,
            name: _ctx.iconRight,
            "is-in-storybook": _ctx.isInStorybook,
            class: "ds-badge__icon-right"
          }, null, 8, ["name", "is-in-storybook"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["href", "rel", "target"]))
}
}

})